$(document).on("click", "#select_all", function() {
    $.ajax({
        type: "POST",
        url: selectionroute+'/all',
        success: function () {
            $('#do_reset_selection').val("0");
            $('#products').DataTable().draw(false);
        },
        fail: function () {
                showAjaxException();
        }
    });
});

$(document).on("click", "#select_none", function() {
    $.ajax({
        type: "POST",
        url: selectionroute+'/none',
        success: function () {
            $('#do_reset_selection').val("0");
            $('#products').DataTable().draw(false);
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#select_visible", function() {
    var selectedids = [];
    $('#products :checkbox').each(function(index, value) {
        selectedids.push($(value).attr('data-id'));
    });

    $.ajax({
        type: "POST",
        url: selectionroute+'/visible',
        data: {'ids' : selectedids},
        success: function () {
            $('#do_reset_selection').val("0");
            $('#products').DataTable().draw(false);
        },
        fail: function () {
            showAjaxException();
        }
    });
});
